import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './Components/Navbar0';
import Analyzer from './Components/Analyzer';
import Alert from './Components/Alert';
import { Route, Routes } from "react-router-dom";
import About from './Components/About';
import Contact from './Components/Contact';
import { HashRouter } from "react-router-dom";
import Gemini from './Components/Summarize';

function App() {

  const [mode, changeMode] = useState("light");
  const [alert, setalert] = useState(null);

  const showalert = (message) => {
    setalert(message);
    setTimeout(() => {
      setalert(null);
    }, 1800);
  };

  useEffect(() => {
    document.body.className = mode === 'dark' ? 'dark-mode' : 'light-mode';
  }, [mode]);

  const modechange = () => {
    changeMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
  }
  
  return (
    <>
    <HashRouter>
      <Navbar modechange={modechange} mode = {mode}/>
      <Alert alert = {alert}/>
     
      <Routes>
          <Route exact path="/textspark" element={<Gemini mode = {mode} />}/>
          <Route exact path="/about" element={<About mode = {mode} />}/>
          <Route exact path="/contact" element={<Contact mode = {mode}/>}/>
          <Route exact path="/" element ={<Analyzer mode = {mode} showalert = {showalert}/>}/>
      </Routes>
      
    </HashRouter>
   </>
  );
}

export default App;
  